import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/olympiq-logo.svg';
import HelpMegaMenu from './HelpMegaMenu';
import MobileMenu from './MobileMenu';
import { useCondensedHeader } from './useCondensedHeader';
import './siteHeader.css';

/** The hamburger/overlay only exist below this width (mockup `stack = vw < 1000`). */
const DESKTOP_NAV_QUERY = '(min-width: 1000px)';

/** Sticky site header — source: mockup L51–146. */
const SiteHeader = (): React.JSX.Element => {
  const condensed = useCondensedHeader();
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = useCallback(() => setNavOpen(false), []);

  // If the viewport grows past the breakpoint while the overlay is open
  // (rotation, window resize), the desktop nav takes over — close the
  // overlay so it doesn't linger invisibly with scroll still locked.
  useEffect(() => {
    const desktopNav = window.matchMedia(DESKTOP_NAV_QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      if (event.matches) setNavOpen(false);
    };
    desktopNav.addEventListener('change', onChange);
    return () => desktopNav.removeEventListener('change', onChange);
  }, []);

  return (
    <>
      <header className={`oq-header${condensed ? ' oq-header--condensed' : ''}`}>
        <div className="oq-header__bar">
          <Link to="/" className="oq-header__brand">
            <img src={logo} alt="Olympiq" width={38} height={38} className="oq-header__logo" />
            <span className="oq-bebas oq-header__wordmark">OLYMPIQ</span>
          </Link>

          <nav className="oq-header__nav">
            <Link to="/" className="oq-header__nav-link">Product</Link>
            <Link to="/compare" className="oq-header__nav-link">Compare</Link>
            <HelpMegaMenu />
            <Link to="/contact-us" className="oq-header__nav-link">Contact</Link>
            <span className="oq-header__divider" aria-hidden="true" />
            <Link to="/contact-us" className="oq-header__cta">Book a demo</Link>
          </nav>

          <button
            type="button"
            aria-label="Menu"
            aria-expanded={navOpen}
            className="oq-header__hamburger"
            onClick={() => setNavOpen(true)}
          >
            <i className="mdi mdi-menu" aria-hidden="true" />
          </button>
        </div>
      </header>

      {navOpen && <MobileMenu onClose={closeNav} />}
    </>
  );
};

export default SiteHeader;
